import React, {Component} from "react";
import PropTypes from "prop-types";
import API_CONSTANTS from "./constants/constants";
import adobeDTM from "./utils/adobeDTM";
import CallToActionBlock from './../components/shared/CallToActionBlock/CallToActionBlock'
import helpers from './../components/utils/helper';
// Reusable dump component which is use to show image only, here we are using it for showing product thumbnails image
const EMPTY_STRING = '';

class Thumbnails extends Component {
    constructor(props) {
        super(props);
        this.state = {imageStatus: 0, thumbnailImgWidth: "90%"};
        this.adobeEvents = new adobeDTM();
        this.adobeEvents.init();
    }

    handleImageLoaded({target:img}) {
        this.setState({imageStatus: 1});
        this.getImageNaturalDimensions(img);
    }

    handleImageErrored() {
        this.setState({imageStatus: 2});
    }

    getImageNaturalDimensions(img) {
        if (img.height > img.width) {
            this.setState({
                thumbnailImgWidth: (img.width * 90) / 1024 + "%"
            });
        }
    }

    logOmnitureEvent(location, url, redirect) {
        const {previewUrl} = this.props;
        this.adobeEvents.clickDTMEvent(location, url, "true");
        if (redirect === "true" && previewUrl == EMPTY_STRING)
            setTimeout(function () {
                // window.location.href = url;
            }, 100);
    }

    showPreview = () => {
        this.props.setShowPreviewFlag(true);
    }

    render() {
        const {shareId, likesCommentDataReducer, recievedLikes} = this.props;
        return (
            <div className="productImage imgContainer layoutStyle">
                {helpers.isMobile() &&
                <React.Fragment>
                    <p className="commonStyle productName">{this.props.productName}</p>
                    <p className="commonStyle productOwner">{this.props.productOwner}</p>
                </React.Fragment>
                }
                <div
                    style={{display: this.state.imageStatus == 1 ? "block" : "none"}}
                >
                    <a
                        onClick={this.logOmnitureEvent.bind(
                            this,
                            "product click",
                            this.props.makeMyOwnUrlWeb,
                            "true"
                        )}
                    >
                        <img
                            id="thumbnailImg"
                            src={this.props.webImgUrl}
                            style={{width: this.state.thumbnailImgWidth}}
                            onLoad={this.handleImageLoaded.bind(this)}
                            onError={this.handleImageErrored.bind(this)}
                            onClick={this.showPreview}
                            align="center"
                        />
                    </a>
                </div>
                <div
                    className="container"
                    style={{display: this.state.imageStatus == 1 ? "none" : "flex"}}
                >
                    <div className="spinner">
                        <img src={API_CONSTANTS.SPINNER_URL}/>
                    </div>

                </div>

                {
                    !helpers.isMobile() &&
                    <CallToActionBlock
                        shareId={shareId}
                        likesCommentDataReducer={likesCommentDataReducer}
                        postLikeUnLike={this.props.postLikeUnLike}
                        editProjectUrl={this.props.editProjectUrl}
                        shareUrl={this.props.shareUrl}
                        originalSharedProjectGuid={this.props.originalSharedProjectGuid}
                    />
                }
            </div>
        );
    }
}

Thumbnails.propTypes = {
    webImgUrl: PropTypes.string,
    mobileImgUrl: PropTypes.string,
    previewUrl: PropTypes.string,
    setShowPreviewFlag: PropTypes.func
};

export default Thumbnails;
